module.exports = __webpack_public_path__ + "static/3-325436d6f640c37da467ef69772f97dc.jpg";